"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function error(component, message) {
    console.error("\u26A0\uFE0F Houston(".concat(component, "): ").concat(message));
}
exports.default = error;
